export default {
  '阳光跑班级报表': 'Sunshine Run Class Report',
  '阳光跑个人报表': 'Sunshine Run Personal Report',
  '班级报表': 'Class Report',
  '学生报表': 'Student Report',
  '跑步人数': 'Runners',
  '未跑人数': 'Non-runners',
  '人均里程': 'Avg Mileage Per Person',
  '班级详情': 'Class Details',
  '导出未跑名单': 'Export Non-runner List',
  '个人报告': 'Personal Report',
  '运动时长': 'Sport Duration',
  '运动次数': 'Sport Count',
  '功能开发中': 'Feature under development'
}
